var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper"},[_c('div',{staticClass:"font-weight-bold title mb-4",class:{'px-3': _vm.$vuetify.breakpoint.xs}},[_vm._t("default")],2),_vm._l((_vm.steps),function(item,i){return _c('stepperItem',{key:i,attrs:{"active":item.active,"disabled":item.disabled,"lesson":i,"block":_vm.block_index}},[_vm._v(_vm._s(item.text))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }